import graphql__f96fe95fa5ca8fd1751e from "./__generated__/AnswerPreviewBudgetDispatcher_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import times from "lodash/times";
import classNames from "classnames";

const AnswerPreviewBudgetDispatcher = props => {
  const { options, maxBudgetPerOption } = props.answer.formField;

  const values = props.answer.dispatchedBudgetValues.reduce((object, weightedOption) => {
    return { ...object, [weightedOption.optionId]: weightedOption.value };
  }, {});

  const starFor = (option, index) => {
    const value = index + 1;
    const optionCurrentValue = values[option.id] || 0;
    const isActive = optionCurrentValue >= value;

    const className = classNames([
      "star",
      {
        "text-white": !isActive,
        "star-empty": !isActive,
        "text-primary": isActive,
        "text-border-primary": isActive
      }
    ]);

    return <div key={index} className={className} />;
  };

  return (
    <div className="budget-dispatcher-preview">
      {options.map(option => (
        <div key={option.id} className="budget-dispatcher-preview-option margin-top-xs">
          <div className="flex-1 text-small d-flex align-items-center">{option.name}</div>

          <div className="stars-container">
            <div className="stars-preview text-greater">
              {times(maxBudgetPerOption, index => starFor(option, index))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default createFragmentContainer(AnswerPreviewBudgetDispatcher, {
  answer: graphql__f96fe95fa5ca8fd1751e
});
